<template>
  <div class="content0-wrapper">
    <div class="bg"></div>
    <div class="content0-content">
      <div class="home-page">
        <div class="content0">
          <div
            v-for="item in newsList"
            :key="item.id"
            class="item"
            @click="toPage(item.url)"
          >
            <div class="date">{{ formatDate(item.date) }}</div>
            <div class="item-left">
              <img
                :src="item.image"
                style="width: 390px; height: 190px"
                referrerpolicy="no-referrer" 
                referrer="no-referrer"
                alt=""
              />
            </div>
            <div class="item-right">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-content">{{ item.abstract }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content2" @click="viewMore" v-if="hasMoreNews" :class="{ loading: pagination.loading }">
        {{ pagination.loading ? '加载中...' : '查看更多' }}
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'Content0',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: 'content0'
    }
  },
  data() {
    return {
      newsList: [],
      props: {},
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        loading: false
      }
    }
  },
  computed: {
    hasMoreNews() {
      const totalPages = Math.ceil(this.pagination.total / this.pagination.pageSize)
      return this.pagination.currentPage < totalPages
    }
  },
  mounted() {
    // 初始化props
    this.props = { ...this.$props }
    delete this.props.dataSource
    delete this.props.isMobile

    // 获取新闻列表
    this.fetchNewsList()
  },
  methods: {
    async fetchNewsList(page = 1, append = false) {
      if (this.pagination.loading) return

      this.pagination.loading = true
      try {
        const params = {
          page: page,
          pageSize: this.pagination.pageSize
        }

        const res = await request.get('/news', { params })

        if (res.success) {
          const newNews = res.data.newsList.map(item => ({
            id: item.id,
            title: item.title,
            abstract: item.summary || '',
            image: item.coverImage,
            date: item.publishTime,
            url: item.sourceUrl || ''
          }))

          if (append) {
            // 累加数据
            this.newsList = [...this.newsList, ...newNews]
          } else {
            // 替换数据
            this.newsList = newNews
          }

          this.pagination.total = res.data.total || 0
          this.pagination.currentPage = page
        }
      } catch (error) {
        console.error('获取新闻列表失败:', error)
        this.$message.error('获取新闻列表失败')
      } finally {
        this.pagination.loading = false
      }
    },
    toPage(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    viewMore() {
      // 检查是否还有更多数据
      const totalPages = Math.ceil(this.pagination.total / this.pagination.pageSize)
      if (this.pagination.currentPage >= totalPages) {
        this.$message.info('没有更多新闻了')
        return
      }

      // 加载下一页
      const nextPage = this.pagination.currentPage + 1
      this.fetchNewsList(nextPage, true)
    },
    formatDate(dateString) {
      if (!dateString) return ''
      try {
        const date = new Date(dateString)
        return date.toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        })
      } catch (e) {
        return dateString
      }
    }
  }
}
</script>

<style scoped>
.content0-wrapper {
  overflow: hidden;
  position: relative;
  background: #fff;
  padding: 0;
  color: #242934;
}

.bg {
  width: 100%;
  height: 440px;
  top: 0;
  left: 0;
  overflow: hidden;
  background: url(@/assets/news_1.png) no-repeat center center / 100% 100%;
}

.content0-content {
  max-width: 1200px;
  margin: 0 auto;
  .home-page {
    padding: 0 24px;
  }
  .content0 {
    margin-top: 90px;
    .item {
      cursor: pointer;
      display: flex;
      position: relative;
      margin-bottom: 100px;
      .date {
        width: 450px;
        height: 46px;
        position: absolute;
        left: 90px;
        top: -14px;
        background: url(@/assets/nav_1.png) no-repeat center center / 100% 100%;
        z-index: 1;
        font-size: 16px;
        font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
        font-weight: 500;
        font-style: italic;
        color: #1074fb;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 40px;
      }
      .item-left {
        z-index: 2;
        img {
          width: 390px;
          height: 260px;
        }
      }
      .item-right {
        margin-left: 36px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        .item-date {
          font-size: 14px;
          font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
          font-weight: 400;
          color: #666;
          margin-bottom: 8px;
        }
        .item-title {
          white-space: nowrap;
          font-size: 24px;
          font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
          font-weight: 500;
          color: #242934;
          line-height: 36px;
          margin-bottom: 12px;
        }
        .item-content {
          font-size: 16px;
          font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
          font-weight: 500;
          color: #242934;
          line-height: 36px;
        }
      }
    }
  }
    .content2 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 175px;
    width: 197px;
    height: 49px;
    border: 1px solid #c6d5e2;
    border-radius: 2px;
    font-size: 18px;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-weight: 400;
    color: #a3b7c9;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .content2:hover {
    background-color: #f0f7ff;
    border-color: #1890ff;
    color: #1890ff;
  }
  .content2.loading {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

.copyright {
  &-wrapper {
    .home-page {
      padding: 0;
      .copyright {
        font-size: 12px;
      }
    }
  }

  span {
    width: 90%;
    display: block;
  }
}

/* 移动端样式修改 - 核心改动区 */
@media screen and (max-width: 767px) {
  .content0-content {
    .home-page {
      padding: 0 20px;
    }
  }
  .content0-wrapper {
    .content0 {
      margin-top: 60px;
      .item {
        margin-bottom: 60px;
        background-color: #e8e4e4;
        padding: 20px;
        /* 隐藏日期标签 */
        .date {
          flex-direction: column;
          position: absolute;
          left: 0px;
          top: -25px;
          background:none;
          z-index: 1;
          font-size: 16px;
          font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
          font-weight: 500;
          font-style: italic;
          color: #1074fb;
          display: flex;
          align-items: flex-start;
          padding-right: 40px;
          justify-content: flex-start;
        }
        /* 核心：隐藏图片容器，彻底不显示图片 */
        .item-left {
          display: none !important;
        }
        /* 优化文字区域布局，占满整行 */
        .item-right {
          width: 100%;
          margin-left: 0;
          .item-title {
            font-size: 18px;
            line-height: 1.4;
            margin-bottom: 8px;
            white-space: normal; /* 标题换行 */
          }
          .item-content {
            font-size: 14px;
            line-height: 1.5;
          }
        }
        .home-page {
          padding: 60px 0 30px;
        }
      }
    }
  }
}

/* 合并重复的移动端样式，避免冲突 */
@media screen and (max-width: 767px) {
  .content0-wrapper {
    .content0 {
      .home-page {
        padding: 64px 24px 32px;
      }
    }
    .copyright {
      &-wrapper {
        .home-page {
          padding: 0;
          .copyright {
            font-size: 12px;
          }
        }
      }
      span {
        width: 90%;
      }
    }
  }
}
</style>